var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIronInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.484 18.048L26.484 0H24.484L20.484 16.048C20.484 16.048 14.484 12 3.48402 12C0.484021 12 -1.51598 16.048 1.48402 23.048C4.48402 30.048 20.484 23.048 22.484 18.048ZM4.48402 15H10.984V16H4.48402V15ZM4.48402 17H15.484V18H4.48402V17ZM4.48402 19H14.109V20H4.48402V19ZM4.48402 21H11.359V22H4.48402V21ZM4.48402 23H7.35902V24H4.48402V23Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronInActiveIcon);
export default __webpack_public_path__ + "static/media/ironInActiveIcon.c47a5c8072a38bd519e2c283876c1604.svg";
export { ForwardRef as ReactComponent };